export const SHOW_MENU = 'menu/show';
export const SHOW_FOOTER = 'footer/show';
export const SHOW_MAIN_HEADER = 'menu/show';
export const RESET_STATE = "reset/state"

export function showMainHeader(show) {
  return {
    type: SHOW_MAIN_HEADER,
    value: show,
  };
}

export function showMenu(show) {
  return {
    type: SHOW_MENU,
    value: show,
  };
}

export function showFooter(show) {
  return {
    type: SHOW_FOOTER,
    value: show,
  };
}

export function resetUtilState(){
  return {
    type: RESET_STATE,
    value: true
  };
}

export function getCoordinateAxleFromStorage(axle) {
  const geolocation = JSON.parse(window.sessionStorage.getItem('geolocation'));
  let coordinate = null;

  if (geolocation) {
    if (axle === 'latitude') {
      coordinate = geolocation.latitude;
    } else if (axle === 'longitude') {
      coordinate = geolocation.longitude;
    }
  }

  return coordinate;
}

export function getRequestAdditionalHeader() {
  return {
    geolocationLatitude: getCoordinateAxleFromStorage('latitude'),
    geolocationLongitude: getCoordinateAxleFromStorage('longitude'),
    details: {
      gaClientId: window.sessionStorage.getItem('gaClientId'),
    },
  };
}
